import React from 'react';
import {
    ListItem as MuiListItem,
    ListItemIcon as MuiListItemIcon,
    ListItemIconProps, ListItemProps,
} from '@material-ui/core';
import styled from 'styled-components';

interface ListItemIconDense extends ListItemIconProps {
    reverse?: boolean;
}

export const ListItemIconDense = styled(({ reverse, ...props }: ListItemIconDense) => (
    <MuiListItemIcon {...props} />
))`
    ${({ theme, reverse }) => `
    && {
        color: ${theme.palette.text.primary};
        min-width: ${theme.spacing(5)}px;
        ${reverse && `justify-content: flex-end;`}
    }
    `}
`;

export const ListItemDense = styled(({ disableGutters, ...props }: Omit<ListItemProps, 'button'>) => (
    <MuiListItem disableGutters {...props} />
))``;
